import "./style.css";
import DatePicker from "react-datepicker";

const AdminInputDatePicker = ({
  prefixIcon = null,
  suffixIcon = null,
  placeholder = "",
  mb = "mb-3",
  onSelectDate,
  label = null,
  value = null,
  hasIndex = false,
  index = null,
  onPrefixIconClick = null,
  onSufixIconClick = null,
  disable = false,
  minDate,
  maxDate,
  iconSize = null,
  containerClassName = "",
  inputClassName = "",
  prefixIconClassName = "",
  suffixIconClassName = "",
  dateFormat = "yyyy-MM-dd",
}) => {
  const getIconStyle = (onClickHandler) => ({
    cursor: onClickHandler ? "pointer" : "default",
    width: iconSize ? `${iconSize}px` : undefined,
    height: iconSize ? `${iconSize}px` : undefined,
  });

  return (
    <>
      <div className={mb}>
        {label && <label className="tw:!mb-1 tw:!text-[15px] tw:!text-[#8D8D8D]">{label}</label>}
        <div className="w-100 rounded border">
          <div className={`tw:flex! tw:justify-center! tw:items-center! d-flex gap-2 input-container tw:items-center ${containerClassName}`}>
            {prefixIcon && (
              <span
                className="ms-3"
                onClick={onPrefixIconClick}
                style={{ cursor: 'pointer' }}
              >
                {prefixIcon}
              </span>
            )}

            <DatePicker
              dateFormat={dateFormat}
              className={`
                tw:border-none 
                tw:outline-none 
                tw:w-full 
                tw:!leading-[32px] 
                tw:rounded 
                tw:border-0 
                tw:py-2 
                tw:!text-[15px] 
                tw:!font-['Hanken_Grotesk'] 
                tw:placeholder:!text-[15px] 
                tw:placeholder:!font-['Hanken_Grotesk'] 
                ${prefixIcon != null ? "" : "px-3"} 
                ${inputClassName}
              `}
              placeholderText={placeholder}
              onSelect={(date) => {
                var formatedDate = date.toLocaleDateString("sv-SE", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                });

                if (hasIndex) {
                  onSelectDate(formatedDate, index);
                } else {
                  onSelectDate(formatedDate);
                }
              }}
              selected={value}
              disabled={disable}
              minDate={minDate}
              maxDate={maxDate}
            />
            {suffixIcon && (
              <span className="me-3" onClick={onSufixIconClick} style={{ cursor: 'pointer' }}>
                {suffixIcon}
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminInputDatePicker;
